import Vue from "vue";

/**
 * Class CPA Service
 */
export default class CpaService extends Vue {
    private customActions = {};
    private resource: any = this.$resource(
        "auth/cpa/{platformId}{/actions}",{},this.customActions
    );

    // GET
    public index(actions?) {
        let platformId = this.$auth.user().id_platform;
        return this.resource.get({ platformId, actions }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }
}
